import { createReducer } from '@reduxjs/toolkit';
import { DeepWritable } from 'ts-essentials';

import { AppUrlOptions } from 'utils/url/createAppUrl';

import { dashboardActions } from './dashboard.actions';

export type DashboardState = {
  lastVisitedUrl?:
    | AppUrlOptions<'/dashboard/queues'>
    | AppUrlOptions<'/dashboard/channels'>
    | AppUrlOptions<'/dashboard/favorites'>;
};

export const initialState: DashboardState = {
  lastVisitedUrl: undefined,
};

export const dashboardReducer = createReducer(initialState, (builder) =>
  builder.addCase(dashboardActions.setLastVisitedUrl, (state, { payload }) => {
    state.lastVisitedUrl = payload as DeepWritable<typeof payload>;
  }),
);
